export default __webpack_public_path__ + "static/media/element_69.1b01d181.jpg";